import {Attribute, Directive, ElementRef, HostListener, Injector, Optional} from '@angular/core';

import {
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  propFactory as PropertiesFactory,
  register,
  styler,
  WIDGET_CONSTANTS
} from "@wm/components-base";
import { $invokeWatchers, $watch, getClonedObject, initCaps, noop, runtimeEventManager, stringStartsWith } from "@wm/core";
import {
  assignIn,
  extend,
  find,
  forEach, get,
  includes, isArray, isEmpty, isEqual,
  isFunction,
  isString,
  keys,
  map, mapValues,
  split,
  startsWith, values
} from "lodash-es";
import {mod} from "ngx-bootstrap/chronos/utils";
const MAIN_PAGE = 'Main';
enum ComponentType {
  PAGE,
  PREFAB,
  PARTIAL
}

const DEFAULT_CLS = 'app-prefab';
const registeredPropsSet = new Set<string>();

interface PREFAB_CONFIG {
  events: any;
  properties: any;
  resources: {
    styles: Array<string>;
    scripts: Array<string>;
  };
  displayName?: string;
  iconUrl?: string;
  group?: any,
  methods?: any,
  id: string | undefined;
}

let prefabDefaultProps = {},
  depsMap: {[key: string]: any} = {},
  prefabWidgetPropsMap: {[key: string]: any} = {},
  prefabMethodsMap: {[key: string]: any}     = {},
  propsSkipList        = ['width', 'height', 'show', 'animation'],
  propertyGroups,
  propertiesGroup: any,
  eventsGroup: any = {};

const WIDGET_CONFIG = {widgetType: 'wm-prefab', hostClass: DEFAULT_CLS};

@Directive({
  selector: 'section[wmPrefab]',
  providers: [
  provideAsWidgetRef(PrefabDirective)
  ],
  exportAs: 'wmPrefab',
  standalone: true
})
export class PrefabDirective extends StylableComponent {
  static initializeProps = register('wm-prefab');

  prefabName: string;
  name: string;
  propsReady: Function;
  private prefabMngr: any;
  private prefabService: any;
  showServerProps: boolean;
  serverProps: { [key: string]: any };
  private _methodsMap: any;
  private prefabid: string | undefined;
  private Widgets: {};
  private variableService: any;
  private showVersionMismatch: boolean ;
  private pfScope: any;
  private componentRefProvider: any;
  private propPanel: any;
  private typeUtilsService: any;
  private projectService: any;
  private projectDetails: any;
  private _watchers: {[key: string]: any} = {};
  constructor(inj: Injector, @Optional() viewParent: Parent, elRef: ElementRef,
              @Attribute('prefabname') prefabName: string
  ) {
    let resolveFn: Function = noop;
    super(inj, WIDGET_CONFIG, viewParent, new Promise(res => resolveFn = res));
    this.propsReady = resolveFn;
    this.prefabName = prefabName;
    this.name = elRef.nativeElement.getAttribute('name');
    this.prefabMngr = runtimeEventManager.getService('PrefabManager');
    this.prefabService = this.prefabMngr.prefabService;
    this.variableService = runtimeEventManager.getService('BaseVariableService');
    this.componentRefProvider = runtimeEventManager.getService('componentRefProvider');
    this.typeUtilsService = runtimeEventManager.getService('TypeFactoryService');
    styler(this.nativeElement, this);
    prefabDefaultProps = PropertiesFactory.getWidgetProperties('wm-prefab');
    this.propPanel = runtimeEventManager.getService('PropertyPanel');
    this.projectService = runtimeEventManager.getService('projectService');
    this.setPrefabPropertyGroups();
  }

  loadDependencies(prefabName: string) {
    this.prefabService.getAppPrefabServerProps({
      'prefabName': prefabName
    }).then((response: any) => {
      let serverProps = response || {};
      this.showServerProps = serverProps && keys(serverProps).length;
      this.serverProps = serverProps;
    });
    return this.prefabMngr.loadAppPrefabConfig(prefabName).then(this.onConfigLoad.bind(this));
  }

  overrideResourcePath(value: string) {
    if (startsWith(value, 'resources/')) {
      return 'WEB-INF/prefabs/' + this.prefabName + '/webapp/' + value;
    }
    return value;
  }

  setPrefabPropertyGroups() {
    let groups = this.propPanel.propertyGroups,
      basicPropsSubGrp;

    let propertyGroups = groups.filter((group: any) => {

      if (group.name === 'properties') {
        propertiesGroup = group;
      } else if (group.name === 'events') {
        eventsGroup = group;
      }

      return !!group.parent;
    });

    basicPropsSubGrp = find(propertiesGroup.subGroups, (subGroup) => {
      return !subGroup.name;
    });

    propsSkipList = propsSkipList.concat(basicPropsSubGrp.properties);
  }

  onConfigLoad(config: PREFAB_CONFIG) {
    let widgetProps: {[key: string]: any} = {},
      userDefinedProps,
      userDefinedEvents,
      userDefinedMethods,
      layoutProps = ['width', 'height'],
      behaviorProps = ['show', 'animation'],
      prefabEvents: Array<any> = [],
      prefabProperties: Array<any> = [];

    const isExists = propertiesGroup.subGroups.find((o: any) => {return o.name === this.prefabName + '_' + 'properties'});

    if (!isExists) {
      propertiesGroup.subGroups.splice(1, 0, {
        'boundPrefabName': this.prefabName,
        'name': this.prefabName + '_' + 'properties',
        'parent': 'properties',
        'properties': prefabProperties,
        'filteredProps': prefabProperties
      }, {
        'boundPrefabName': this.prefabName,
        'name': this.prefabName + '_' + 'layout',
        'displayKey': 'LABEL_PROPERTYGROUP_LAYOUT',
        'parent': 'properties',
        'properties': layoutProps,
        'filteredProps': layoutProps
      }, {
        'boundPrefabName': this.prefabName,
        'name': this.prefabName + '_' + 'behavior',
        'displayKey': 'LABEL_PROPERTYGROUP_BEHAVIOR',
        'parent': 'properties',
        'properties': behaviorProps,
        'filteredProps': behaviorProps
      });

      eventsGroup.subGroups.push({
        'boundPrefabName': this.prefabName,
        'name': this.prefabName + '_' + 'events',
        'parent': 'events',
        'properties': prefabEvents
      });

    userDefinedProps = config.properties || {};
    userDefinedEvents = config.events || {};
    userDefinedMethods = config.methods || {};

    this.prefabid = config.id;

    forEach(userDefinedProps, (prop, key) => {
      widgetProps[key] = prop;

      if (stringStartsWith(prop.value, 'bind:')) {
        prop.__value = prop.value;
        prop.value = undefined;
      }

      prop.value = this.overrideResourcePath(prop.value);

      if (!includes(propsSkipList, key)) {
        prefabProperties.push(key);
      }

      if (prop.hasOwnProperty('options') && stringStartsWith(prop.options, 'bind:')) {
        prop.__options = prop.options;
        delete prop.options;
      }

      if (prop.bindable === 'out-bound') {
        prop.show = false;
        prop.showAt = undefined;
      } else if (!prop.hasOwnProperty('show')) {
        prop.show = true;
      } else if (stringStartsWith(prop.show, 'bind:')) {
        prop.__show = prop.show;
        prop.show = true;
      }

      if (!prop.hasOwnProperty('disabled')) {
        prop.disabled = false;
      } else if (stringStartsWith(prop.disabled, 'bind:')) {
        prop.__disabled = prop.disabled;
        prop.disabled = false;
      }

      if (prop.type === 'number' && prop.widget === 'list') {
        prop.widget = 'list-number';
      }

      prop.widget = prop.type === 'date' ? 'date' : prop.widget;

      if (prop.value && prop.type === 'date') {
        prop.value = new Date(prop.value);
      }

      prop.label = initCaps(key);
      prop.helpText = prop.description;

    });

    forEach(userDefinedEvents, (prop, key) => {
      widgetProps[key] = prop;

      prefabEvents.push(key);

      prop.displayName = prop.displayName ? 'On ' + prop.displayName : '';
      prop.show = true;
      prop.disabled = false;
      prop.type = 'event';
      prop.widget = 'eventlist';
      prop.options = WIDGET_CONSTANTS.EVENTS_OPTIONS;
      prop.helpText = prop.description;
    });
  }

    if (prefabWidgetPropsMap[this.prefabName]) {
      this.widgetProps = getClonedObject(prefabWidgetPropsMap[this.prefabName]);
      this._methodsMap = prefabMethodsMap[this.prefabName];
      runtimeEventManager.emit('wms:refresh-properties-panel');
      return;
    }

    forEach(prefabDefaultProps, (prop, key) => {
      if (widgetProps[key] === undefined) {
        widgetProps[key] = prop;
      }
    });

    prefabWidgetPropsMap[this.prefabName] = widgetProps;
    prefabMethodsMap[this.prefabName]     = userDefinedMethods;

    this.widgetProps = getClonedObject(prefabWidgetPropsMap[this.prefabName]);
    this._methodsMap = prefabMethodsMap[this.prefabName];
    registeredPropsSet.add(this.widgetType);
    runtimeEventManager.emit('widgetSelection');
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loadDependencies(this.prefabName).then(() => {
      if (!depsMap[this.prefabName]) {
        this.prefabMngr.loadDependencies(this.prefabName)
          .then((templateContent: string) => {
            let _content = this.prefabMngr.updateHTMLImportRefs(this.prefabName, templateContent);
            depsMap[this.prefabName] = {
              'templateContent': _content
            };
            this.compileTemplate(_content);
          }, () => {
            this._methodsMap = {}; //needed as this will be used while generating prefab event options when config load fails
          });
      } else { //dependencies already loaded.
        this.compileTemplate(depsMap[this.prefabName].templateContent);
      }
      this.showServerProps = !!(this.serverProps && keys(this.serverProps).length);
    });
    this.projectDetails = this.projectService.getDetails();
  }

  setPrefabWidgetId(markup: JQuery<HTMLElement>, page: string, prefabname: string, childWidgets: Array<string>) {
    forEach(markup?.find('[name]'), (el) => {
      let $this = $(el),
        name = $this.attr('name');
      if (name && find(childWidgets, (n: string) => {
        let showAtWidget = split(n, '.');
        return showAtWidget[1] === name && showAtWidget[0] === page
      })) {
        $this.attr('prefab-widget-id', prefabname + '.' + page + '.' + name);
      }
    });
    return markup;
  }

  compileTemplate(prefabContent: string) {
    let versionMsg = this.prefabMngr.getVersionMismatchMessage(this.prefabName),
    versionMsgEle;
    let childWidgets: Array<string> = [];;
    this.showVersionMismatch = versionMsg ? true : false;

    if (this.showVersionMismatch) {
      versionMsgEle = '<div class="badge prefab-version" >' +
        '<i class="wms wms-flask"   title="'  + versionMsg + '"></i>' +
        '</div>'
    } else {
      versionMsgEle=" "
    }

     let prefabEle= versionMsgEle + '<div class="full-width full-height">' + prefabContent + '</div>',
      $prefabEle= $(prefabEle),
      hasParentPrefab= this.$element.parent().closest('[data-role="prefab"]').length > 0;

    if (!hasParentPrefab) {
      map(this.widgetProps, (p) => {
        p.isHidden = p.show === false;
        if (isString(p.showAt) && p.showAt !== '') {
          p.show = !p.showAt;
          if (!p.isHidden) {
            childWidgets.push(p.showAt);
          }
        }
      });
      // TODO: check this instead of uniqBy
      childWidgets = Array.from(new Set(childWidgets));
      this.setPrefabWidgetId($prefabEle, MAIN_PAGE, this.prefabName, childWidgets);

      // $rs.$on('partial-show-at-widget', function (event, options) {
      //   this.setPrefabWidgetId($(options.markup), options.partialName, options.prefabName);
      // });
    }

    this.Widgets = {};
    this.pfScope = extend({}, this);
    this.pfScope.Variables = this.Variables;
    this.pfScope.isStudioMode = true;
    this.showVersionMismatch = versionMsg ? true : false;
    // register the page variables for prefab
    const variableConstants = this.variableService.getVariableConstants();
    const prefabName =  this.projectDetails.type === 'APPLICATION' ? variableConstants.PREFAB_PREFIX + this.prefabName : this.prefabName;
    this.variableService.getPageVariables(prefabName).then((variables: any) => {
      this.variableService.register(prefabName, variables, true, this.pfScope);
      this.$element.append($prefabEle);
      setTimeout(() => {
        const targetClasses = [
          '.app-wizard-skip',
          '.app-wizard-cancel',
          '.app-wizard-previous', 
          '.app-wizard-next',
          '.app-wizard-done'
        ];
        
        targetClasses.forEach(className => {
          const elements = this.$element[0].querySelectorAll(className);
          elements.forEach((element : HTMLElement) => {
            if (element && element.hasAttribute('hidden')) {
              element.removeAttribute('hidden');
            }
          });
        });
      }, 100);

      this.componentRefProvider.getComponentFactoryRef(this.prefabName, ComponentType.PREFAB, {widgetRef: this, listener: (markup: string) => {
          let $dom = $(markup);
          let modifiedMarkup = this.setPrefabWidgetId($dom, MAIN_PAGE, this.prefabName, childWidgets);
          return modifiedMarkup[0].outerHTML;
        }}).then((compRef: any) => {
        let instance = compRef.instance;
        let compiledEl = compRef.location.nativeElement;
        this.$element.find('.full-width.full-height').html('');
        this.$element.find('.full-width.full-height').append($(compiledEl));
        this.onReady(instance);
        this.onTemplateLoad();
      });
    });
  }

  onReady(instance: any) {
    assignIn(this.pfScope, this);
    setTimeout(() => {
      instance.initUserScript(this.pfScope);
      instance.registerProps();
      this.pfScope.onReady && this.pfScope.onReady();
    });
    this.registerReadyStateListener(() => {
      $invokeWatchers(true);
    });
  }

  /* called on load of the prefab template*/
  onTemplateLoad() {
  //   var script = this.prefabMngr.getScriptOf(prefabName);
  //
  //   var fn = new Function('Prefab', 'App', 'Utils', script);
  //
  //   $is.pfScope.isStudioMode = true;
  //
  //   fn($is.pfScope, getAppContext(), Utils, true);
  //
  //   /* scope of the controller */
  //
    forEach(this.widgetProps, (propDetails, propName) => {
      if (propDetails.__value && !this.$attrs.get(propName)) {
        let key = propDetails.__value.replace('bind:', '');
        // this._watchers[propName] = $watch(key, this, {}, (nv: any) => {
        //   this[propName + '__updateFromWatcher'] = true;
        //   // this[propName] = overrideResourcePath($is, nv);
        // });
      }
      if (propDetails.__options) {
        let bindOptKey = propDetails.__options.replace('bind:', '');
        this._watchers[propName + '_options'] = $watch(bindOptKey, this, {}, (nv: any) => {
          if (!isEmpty(nv) && isArray(nv)) {
            this.widgetProps[propName].options = [''].concat(nv);
          } else {
            this.widgetProps[propName].options = [];
          }
        });
      }
      if (propDetails.__show) {
        let key = propDetails.__show.replace('bind:', '');
        this._watchers[propName + '_show'] = $watch(key, this, {}, (nv: any) => {
          this.widgetProps[propName].show = nv;
          // this._watchers[propName + '_show'] = this.pfScope.$watch(key, (nv: any) => {
          //   this.widgetProps[propName].show = nv;
          // });
        });
      }
      if (propDetails.__disabled) {
        let key = propDetails.__disabled.replace('bind:', '');
        this._watchers[propName + '_disabled'] = $watch(key, this, {}, (nv: any) => {
          this.widgetProps[propName].disabled = nv;
          // this._watchers[propName + '_disabled'] = this.pfScope.$watch(key, (nv: any) => {
          //   this.widgetProps[propName].disabled = nv;
          // });
        });
      }
    });
  //
  //   WidgetUtilService.registerPropertyChangeListener(propertyChangeHandler.bind(undefined, $is), $is);
  //   WidgetUtilService.postWidgetCreate($is, $el, attrs);
  //
  //   Utils.triggerFn($is.pfScope.onReady);
  //   if (CONSTANTS.isRunMode) {
  //     Utils.triggerFn($is.onLoad);
  //
  //     $is.$on('$destroy', $is.onDestroy);
  //   }
  //
  //   $is.ctrlScope = $is.pfScope;
  //   //once the template is loaded, expose methods on the prefab widget
  //   exposeMethodsOnWidget($is);
  }

  public setProps(config: any) {
    if (!config || !config.properties) {
      return;
    }

    if (!registeredPropsSet.has(this.widgetType)) {
      register(this.widgetType, this.prepareProps(config));
    }

    this.propsReady();
  }

  private prepareProps(config: any) {
    this.onConfigLoad(config);
    return this.widgetProps;
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    super.onPropertyChange(key, nv, ov);
    let bindKey = get(this, 'bind' + key);
    let pfScopeBindKey = get(this.pfScope, 'bind' + key);
    if (this.widgetProps && this.widgetProps[key] && ['in-bound', 'in-out-bound'].indexOf(this.widgetProps[key].bindable) > -1) {
      let expr = pfScopeBindKey || bindKey;
      if (expr) {
        let columns = this.typeUtilsService.getFieldsForExpr(expr);
        if (columns.length > 0) {
          this.widgetProps[key].keys = columns;
        } else {
          this.widgetProps[key].keys = [];
        }
      }
    }
    if (isFunction(this.pfScope?.onPropertyChange)) {
      // to reflect the prop changes on prefab directive, and apply the same on pfScope of prefab.
      if (bindKey) {
        this.pfScope['bind' + key] = bindKey;
      }
      this.pfScope[key] = nv;
      try {
        this.pfScope.onPropertyChange(key, nv, ov);
      } catch (e) {
        console.warn(`Error in evaluating prefab (${this.prefabName}) script\n`, e);
      }
    }
    if (!isEmpty(this._watchers) || (key !== 'active' && !isEqual(nv, ov))) {
      $invokeWatchers(true);
    }
  }

}

